var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #cd9643;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.8,15.1h0c-1.4-1.3-3.1-2-5-2H7.2c-1.8,0-3.5.7-4.9,1.9h0c-1.5,1.4-2.3,3.3-2.3,5.3v34.8c0,2.2,1,4.2,2.7,5.6,1.3,1.1,2.9,1.6,4.6,1.6h61.2c1.5,0,2.9-.8,4.1-1.8h0c1.6-1.4,2.5-3.4,2.5-5.5V20.3c0-2-.8-3.8-2.2-5.2h-.1ZM46.1,40.7l25.5-22.3c.3.6.5,1.2.5,1.9v34.8c0,.9-.3,1.7-.7,2.4l-25.2-16.8h-.1ZM67.8,16c.5,0,1.1.1,1.6.3l-30,26.3c-.9.8-2.4.8-3.3,0L5.9,16.3c.4-.1.9-.2,1.4-.2h60.5ZM3,55.1V20.3c0-.7.2-1.5.6-2.1l25.7,22.5L3.8,57.6c-.5-.7-.8-1.6-.8-2.5ZM7.2,59.3h-.5l24.9-16.6,2.4,2.1c1,.9,2.3,1.4,3.6,1.4s2.6-.5,3.6-1.4l2.4-2.1,24.9,16.5H7.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f9a91c5d5bae9b81016f1f27c18fc1ab.svg";
export { ForwardRef as ReactComponent };